<template>
  <b-container fluid>
    <!-- Main table element -->
    <b-table
      :items="planDetails"
      :fields="fields"
      :busy.sync="loading"
      stacked="md"
      show-empty
      @filtered="onFiltered"
      bordered
      borderless
      striped
      empty-filtered-text="لا يوجد نتائج تطابق البحث"
      empty-text="لا يوجد سجلات لعرضها"
    >
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle mx-2"></b-spinner>
          <strong>جاري التحميل...</strong>
        </div>
      </template>
      <template v-if="!isUrgent" #cell(name)="row">
        <div class="d-flex align-items-center">
          <h5 class="mb-0">
            {{ row.value }}
          </h5>

          <b-button
            @click="row.toggleDetails"
            class="btn-icon rounded-circle mr-25"
            variant="flat-secondary"
            size="sm"
            v-if="row.item.planned_activities.length > 0"
          >
            <feather-icon
              size="15"
              :icon="row.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            />
          </b-button>
        </div>
      </template>
      <template #cell(actions)>
        <div class="pr-4"></div>
      </template>
      <!-- 
      <template #cell(beneficiaries_number)="row">
        {{
          row.item.information ? row.item.information.beneficiaries_number : ""
        }}
      </template>


      <template v-for="n in 12" v-slot:[`cell(${n})`]="{ value }">
        <feather-icon
          v-if="value"
          size="15"
          class="text-success"
          icon="CheckCircleIcon"
        />
      </template>

      <template v-if="!isArchived" #cell(actions)="row">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>

          <b-dropdown-item @click="$emit('editClicked', row.item)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">تعديل</span>
          </b-dropdown-item>

          <b-dropdown-item @click="$emit('deleteClicked', row.item)">
            <feather-icon icon="Trash2Icon" />
            <span class="align-middle ml-50">حذف</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
 -->

      <template v-for="n in 12" v-slot:[`cell(${n})`]="row">
        <template v-if="isUrgent">
          <feather-icon
            v-if="
              row.item.information.months &&
              (row.item.information.months.includes(n) ||
                row.item.information.months.includes(`${n}`))
            "
            size="15"
            class="text-success"
            icon="CheckCircleIcon"
          />
        </template>
      </template>

      <template v-if="!isUrgent" #row-details="row">
        <b-table
          :fields="activitesFields"
          responsive="sm"
          :items="row.item.planned_activities"
          striped
        >
          <template v-for="n in 12" v-slot:[`cell(${n})`]="row">
            <feather-icon
              v-if="
                row.item.information.months &&
                (row.item.information.months.includes(n) ||
                  row.item.information.months.includes(`${n}`))
              "
              size="15"
              class="text-success"
              icon="CheckCircleIcon"
            />
          </template>

          <template #cell(actions)="{ item }">
            <b-dropdown 
              variant="link"
              no-caret
              v-if="!evaluated && canAddTransaction"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <!-- <b-dropdown-item @click="$emit('editClicked')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">تعديل</span>
              </b-dropdown-item> -->

              <b-dropdown-item @click="$emit('deleteClicked', item.id)">
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">حذف</span>
              </b-dropdown-item>
            </b-dropdown>
            <feather-icon
              v-else
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle px-2 text-muted"
            />
          </template>
        </b-table>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import {
  BButton,
  BCard,
  BModal,
  BTable,
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BInputGroup,
  BPagination,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BButton,
    BCard,
    BModal,
    BTable,
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BInputGroup,
    BPagination,
    BFormSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  props: {
    planDetails: Array,
    loading: Boolean,
    isArchived: {
      type: Boolean,
      default: () => true,
    },
    isUrgent: {
      type: Boolean,
      default: () => false,
    },
    evaluated: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      items: [
        {
          name: "برنامج محو الأمية",
          num: 2904,
          price: 2500000,
          1: true,
        },
      ],
      fields: [
        {
          key: "name",
          label: this.isUrgent ? "النشاط" : "البرنامج",
          class: "th-width",
        },
        {
          key: "1",
          label: "ك 2",
          class: "text-center px-2",
        },
        {
          key: "2",
          label: "شباط",
          class: "text-center px-2",
        },
        {
          key: "3",
          label: "آذار",
          class: "text-center px-2",
        },
        {
          key: "4",
          label: "نيسان",
          class: "text-center px-2",
        },
        {
          key: "5",
          label: "أيار",
          class: "text-center px-2",
        },
        {
          key: "6",
          label: "حزيران",
          class: "text-center px-2",
        },
        {
          key: "7",
          label: "تموز",
          class: "text-center px-2",
        },
        {
          key: "8",
          label: "آب",
          class: "text-center px-2",
        },
        {
          key: "9",
          label: "أيلول",
          class: "text-center px-2",
        },
        {
          key: "10",
          label: "ت 1",
          class: "text-center px-2",
        },
        {
          key: "11",
          label: "ت 2",
          class: "text-center px-2",
        },
        {
          key: "12",
          label: "ك 1",
          class: "text-center px-2",
        },

        {
          key: "information.beneficiaries_number",
          label: "عدد المستفيدين",
          class: "text-center px-2",
        },
        {
          key: "information.funds",
          label: "الموازنة",
          class: "text-center px-2",
        },

        { key: "actions", label: "" },
      ],
      activitesFields: [
        {
          key: "name",
          label: "اسم النشاط",
          class: "th-width pl-5",
        },
        {
          key: "1",
          label: "ك 2",
          class: "text-center px-2",
        },
        {
          key: "2",
          label: "شباط",
          class: "text-center px-2",
        },
        {
          key: "3",
          label: "آذار",
          class: "text-center px-2",
        },
        {
          key: "4",
          label: "نيسان",
          class: "text-center px-2",
        },
        {
          key: "5",
          label: "أيار",
          class: "text-center px-2",
        },
        {
          key: "6",
          label: "حزيران",
          class: "text-center px-2",
        },
        {
          key: "7",
          label: "تموز",
          class: "text-center px-2",
        },
        {
          key: "8",
          label: "آب",
          class: "text-center px-2",
        },
        {
          key: "9",
          label: "أيلول",
          class: "text-center px-2",
        },
        {
          key: "10",
          label: "ت 1",
          class: "text-center px-2",
        },
        {
          key: "11",
          label: "ت 2",
          class: "text-center px-2",
        },
        {
          key: "12",
          label: "ك 1",
          class: "text-center px-2",
        },

        {
          key: "information.beneficiaries_number",
          label: "عدد المستفيدين",
          class: "text-center px-2",
        },
        {
          key: "information.funds",
          label: "الموازنة",
          class: "text-center px-2",
        },

        { key: "actions", label: "" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss">
.b-table-details {
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f8f8f8;
  }
  > td {
    padding-left: 0px;
    padding-right: 0px;
  }
  th {
    padding: 0 2rem;
    visibility: hidden;

    div {
      visibility: hidden;
    }
    font-size: xx-small;
  }
}
.th-width {
  width: 200px;
}
</style>
